import { render } from "./UserMenuComponent.vue?vue&type=template&id=27cb726c&scoped=true"
import script from "./UserMenuComponent.vue?vue&type=script&lang=js"
export * from "./UserMenuComponent.vue?vue&type=script&lang=js"

import "./UserMenuComponent.vue?vue&type=style&index=0&id=27cb726c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cb726c"]])

export default __exports__